import React from "react";

export const Gallery = (props) => {
  const partners = props.data || [];
  const partnerMeta = {
    MBZUAI: {
      shortName: "MBZUAI",
      fullName: "Mohamed bin Zayed University of Artificial Intelligence",
    },
    CMU: {
      shortName: "CMU",
      fullName: "Carnegie Mellon University",
    },
    "The University of Sydney": {
      shortName: "USYD",
      fullName: "The University of Sydney",
    },
    Conahcyt: {
      shortName: "Conahcyt",
      fullName: "Consejo Nacional de Humanidades Ciencias y Tecnologias",
    },
  };

  return (
    <section id="portfolio" className="collaboration-section">
      <div className="container collaboration-shell">
        <div className="collaboration-header">
          <div className="collaboration-intro">
            <p className="section-kicker">Global Network</p>
            <h2>Built with world-class partners</h2>
            <p className="collaboration-lede">
              Research partners help us validate, refine, and scale real
              products
            </p>
          </div>
        </div>

        <div className="collaboration-board">
          <div className="collaboration-grid" aria-label="CradleAI collaborators">
            {partners.length
              ? partners.map((partner, index) => {
                  const meta = partnerMeta[partner.title] || {
                    shortName: partner.title,
                    fullName: partner.title,
                  };

                  return (
                    <article
                      key={`${partner.title}-${index}`}
                      className="collaboration-node"
                    >
                      <div className="collaboration-node-logo">
                        <img src={partner.smallImage} alt={`${partner.title} logo`} />
                      </div>
                      <div className="collaboration-node-copy">
                        <h4>{meta.shortName}</h4>
                        <p>{meta.fullName}</p>
                      </div>
                    </article>
                  );
                })
              : null}
          </div>
        </div>
      </div>
    </section>
  );
};
